import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

export const PrivateRouteUser = () => {
    const auth = useSelector((data) => data?.auth);
    return (auth?.isLoggedIn && (auth?.userRole == 'USER' || auth?.userRole == 'TRAVELLER')) ? <Outlet /> : <Navigate to="/login" />;
};


export const PrivateRouteAdmin = () => {
    const auth = useSelector((data) => data?.auth);
    return (auth?.isLoggedIn && auth?.userRole == 'ADMIN') ? <Outlet /> : <Navigate to="/login" />;
};


export const PrivateRouteTraveller = () => {
    const auth = useSelector((data) => data?.auth);
    return (auth?.isLoggedIn && auth?.userRole == 'TRAVELLER') ? <Outlet /> : <Navigate to="/login" />;
};

 